import { useEffect, useState } from "react";
import { IPanelTipoEquipoEditar } from "./PanelTipoEquipoEditar";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { ITipoEquipoEdit } from "../../../../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo";
import TipoEquipoService from "../../../../../services/ListaVerificacion/TipoEquipoService";

export const UsePanelTipoEquipoEditar=(props:IPanelTipoEquipoEditar)=>{
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const initial:ITipoEquipoEdit={
        codigo: "",
        nombre: "",
        tipoEquipoId: ""
    }
    const [request,setRequest]=useState<ITipoEquipoEdit>(initial)

     const reset=()=>{
         setMensaje("")
         setRequest(initial)
         setStatus(0)
         props.onDismiss()
     }
   
     useEffect(()=>{
        if(props.isOpen){
          setRequest({...request,codigo:props.item.codigo,
            nombre:props.item.nombre,tipoEquipoId:props.item.tipoEquipoId})
          }
      },[props.isOpen])
     
     const putEditarTipoEquipo=()=>{
        setLoading(true)
        TipoEquipoService.UpdateAuxiliar(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
           
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
     return {request,setRequest,putEditarTipoEquipo,loading,reset,mensaje,status}

}